<template>    
  <div class="content">
 
    <b-container fluid >
      <div>
        <card class="no-border-card" body-classes=" p-4" footer-classes="pb-2">

          <b-row class="justify-content-md-center" align-v="center" >
            <b-col>
              <h1 class="mb-0">Quick Replies</h1>
            </b-col>
            <b-col class="float-right">
              <base-button icon type="success" class="float-right"  @click="toggle_new_quick_reply_modal" >
                <span class="btn-inner--icon"><span class="material-icons material-icons-outlined md-18">add_circle_outline</span></span>
                <span class="btn-inner--text">Create Quick Reply</span>
              </base-button>
            </b-col>
          </b-row>
        </card>

        <!-- quick_reply table -->
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2" v-if="$parent.quick_replies.length > 0">
          <div>
            <b-col class="d-flex justify-content-center justify-content-sm-between flex-wrap float-right mb-4">
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <!--
              <div>
                <base-input v-model="searchQuery"
                            prepend-icon="fas fa-search"
                            placeholder="Search...">
                </base-input>
              </div>
              -->
            </b-col>
          </div>
          <div>
            <el-table :data="tableData"
                      row-key="id"
                      header-row-class-name="thead-light"
                      @sort-change="sortChange"
                      
                      >

                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  v-bind="column"
                >
                </el-table-column>

                <el-table-column align="right" label="Fallback Text">
                  <div slot-scope="{$index, row}" class="w-100">
                    <base-input >
                      <textarea class="form-control" v-model="row.text_fallback" rows="3" @change="change_this_quick_reply($index,row)"></textarea>
                    </base-input>
                  </div>
                </el-table-column>

                <el-table-column align="right" label="Personalized Text">
                  <div slot-scope="{$index, row}" class="w-100">
                    <base-input >
                      <textarea class="form-control" v-model="row.text_handlebars" rows="3" @change="change_this_quick_reply($index,row)"></textarea>
                    </base-input>
                  </div>
                </el-table-column>

                <el-table-column  align="right" label="Image">

                  <div slot-scope="{$index, row}">
                    <base-input 
                      v-model="row.sms_attachment"
                      class="mb-1"
                      placeholder="SMS Attachment"
                      @change="change_this_quick_reply($index,row)"
                      >
                    </base-input>
                    
                    <div class="new_quick_reply_image_contain">
                      <img  v-if="row.sms_attachment" :src="row.sms_attachment" alt="SMS image preview. invalid URL or file not accessible to web." class="w-100">
                    </div>
                  </div>
                
                </el-table-column>




                <el-table-column  align="right" label="Active">
                  <div slot-scope="{$index, row}" class="d-flex" @click="change_this_quick_reply($index,row)">
                    <base-switch class="mr-1" v-model="row.is_active" ></base-switch> 
                  </div>
                </el-table-column>

               
             
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{selectedRows.length}} rows selected
                </span>
              </p>

            </div>
            <base-pagination
              class="pagination-no-border"
              :current="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
              @change="paginationChanged($event)"
            >
            </base-pagination>
          </div>
        </card>
        <!-- quick_reply table -->

      </div>

      <!-- new quick_reply modal -->
      <div>
      
        <modal :show.sync="modals.new_quick_reply.show_modal" class="modal-xl" body-classes="p-0" id="new_quick_reply_modal" ref="new_quick_reply_modal"
         
        >


          <card
                header-classes="bg-transparent pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0 mb-0">

              <div class="text-muted text-center mt-2 mb-3">
                <h2>Create New Quick Reply</h2>
              </div>

              <div v-if="this.modals.new_quick_reply.errors && this.modals.new_quick_reply.errors.length > 0">
               
                <b-alert show variant="danger" v-for="new_quick_reply_errors in this.modals.new_quick_reply.errors" :key="new_quick_reply_errors"
                                :error_text="new_quick_reply_errors" >
                  <strong>{{new_quick_reply_errors}}</strong>
                </b-alert>
              </div>

              <b-form role="form">
                <base-input alternative
                            v-model="modals.new_quick_reply.form_data.quick_reply_name"
                            class="mb-3"
                            placeholder="Quick Reply Name"
                            prepend-icon="drive_file_rename_outline">
                </base-input>
                
                <b-form-group label="Active" style="font-weight: 600;font-size: 0.875rem;" class="mb-2">
                  <base-switch class="mr-1" v-model="modals.new_quick_reply.form_data.is_active"></base-switch>
                </b-form-group>

                <base-input alternative
                            v-model="modals.new_quick_reply.form_data.text_short_name"
                            class="mb-3"
                            placeholder="Short Name"
                            prepend-icon="short_text">
                </base-input>

                <base-input label="Text Fallback" prepend-icon="textsms">
                  <textarea class="form-control" id="text_fallback" v-model="modals.new_quick_reply.form_data.text_fallback" rows="3"></textarea>
                </base-input>

                
                <base-input label="Personalized Text" prepend-icon="code">
                  <textarea class="form-control" id="text_handlebars" v-model="modals.new_quick_reply.form_data.text_handlebars" rows="3"></textarea>
                </base-input>
                <p>Put defined contact fields like <span v-pre>{{active_user.first_name}}</span></p>

                <base-input alternative
                  v-model="modals.new_quick_reply.form_data.sms_attachment"
                  class="mb-3"
                  placeholder="SMS Attachment URL"
                  prepend-icon="add_photo_alternate">
                </base-input>
                <div class="new_quick_reply_image_contain">
                  <img  v-if="modals.new_quick_reply.form_data.sms_attachment" :src="modals.new_quick_reply.form_data.sms_attachment" alt="SMS image preview. invalid URL or file not accessible to web." class="w-25">
                </div>

           
                <base-input label="Script">
                  <el-select v-model="selected_script_uuid_for_watch"
                            filterable
                            >
                    <el-option v-for="script in this.$parent.scripts"
                              :key="script.script_uuid"
                              :label="script.script_name"
                              :value="script.script_uuid"
                              
                              >
                    </el-option>
                  </el-select>
                  <!--v-b-tooltip.hover.bottom :title="script.script_text_fallback"-->
                </base-input>

                <h3>Associated With Survey Question</h3>

                <div v-if="this.available_survey_questions && this.available_survey_questions.length && available_survey_questions.length > 0">
                  <b-form-group label="Active" style="font-weight: 600;font-size: 0.875rem;" class="mb-2">
                    <base-switch class="mr-1" v-model="modals.new_quick_reply.form_data.survey_question_affiliated"></base-switch>
                  </b-form-group>

                  <base-input label="Suvey Question" ref="new_sc_dropdown">
                    
                    <el-select v-model="survey_question_uuid_for_watch"
                              
                              filterable
                              >
                      <el-option v-for="this_sc in  this.available_survey_questions"
                                :key="this_sc.survey_question_uuid"
                                :label="this_sc.survey_question_name"
                                :value="this_sc.survey_question_uuid">
                      </el-option>
                    </el-select>
                  </base-input>

                  <div class="data_types" v-if="this.modals.new_quick_reply.form_data.survey_question_uuid && this.show_sc_area === true ">
                    <survey_question_form 
          
                      @changeMsg="set_sc_data"
                      @close_survey_question_ui="close_sc_area()"
                      :msg="this.survey_question_response_data"
                      v-bind:show_save_buttons="true"
                      v-bind:survey_question="this.associated_survey_question"
                      v-on:close_ui_function="this.close_example()">
                    </survey_question_form>
                  </div>

                  <div if="this.survey_question_response_data && this.survey_question_response_data !==''">
                    <p>Quick reply will save this data automatically:</p>
                    <h2>{{this.survey_question_response_data}}</h2>
                  </div>
                  
                </div>
                <div v-else>
                  <p @click="this.$parent.change_tab('survey_questions')">There are no survey questions. Create one or place one inside this script.</p>
                </div>
                
                
              
              </b-form>

              

          </card>

          
      

         <template slot="footer">
          <base-button type="danger" @click="close_new_quick_reply_modal()">Cancel</base-button>
          <base-button type="success" @click="submit_new_quick_reply()" :disabled="modals.new_quick_reply.is_busy" ref="create_quick_reply_button">Create Quick Reply <i v-if="modals.new_quick_reply.is_busy" class="fas fa-spinner fa-spin"></i> </base-button>
          

        </template>
        </modal>


      </div>


    </b-container>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import { BasePagination } from '@/components';
import clientPaginationMixin from './PaginatedTables/clientPaginationMixin'
import swal from 'sweetalert2';
import { BModal } from 'bootstrap-vue'
import survey_question_form from '@/components/survey_question_form.vue'



export default {
  mixins: [clientPaginationMixin],
  components: {
    BModal,
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    survey_question_form:survey_question_form
  },
  data() {
    return {
      survey_question_response_data:'',
      show_sc_area: false,
      is_inside_change_data_callback: false,
      selected_script_uuid_for_watch:null,
      available_survey_questions: [],
      changed_row_index_numbers: [],
      //propsToSearch: ['quick_reply_name'],
      tableColumns: [
        /*
        {
          type: 'selection'  //check boxes for bulk edit in the future
        },*/
        {
          prop: 'quick_reply_name',
          label: 'Name',
          sortable: true
        },
        {
          prop: 'text_short_name',
          label: 'Title',
          sortable: true
        },
        {
          prop: 'date_created',
          label: 'Date',
          sortable: true,
          formatter: (value, key, item) => {
            return new Date(item).toLocaleDateString();
          }
        },
        {
          prop: 'survey_question_uuid',
          label: 'Survey Question',
          sortable: true,
          formatter: (value, key, item) => {
            let this_name = null
            this.$parent.survey_questions.forEach((survey_question,index) => {

              if(survey_question.survey_question_uuid === item) {
                if(this_name === null) {
                  this_name = survey_question.survey_question_name
                }
              }
            })

            return this_name
          
          }
        },
        {
          prop: 'survey_question_answer_value',
          label: 'Answer',
          sortable: false
        }
        
      ],
      tableData: this.$parent.quick_replies,
      selectedRows: [],
      modals: {
        new_quick_reply: {
          show_modal: false,
          is_busy: false,
          errors: [

          ],
          default_form_data: {
            "org_id":this.$parent.active_org.org_id,
            "user_uuid_created":this.$parent.active_user.user_uuid,
            "user_uuid_last_modified":this.$parent.active_user.user_uuid,
            "script_uuid":null,
            "quick_reply_uuid":null,
            quick_reply_name:null,
            text_short_name:null,
            text_fallback:null,
            text_handlebars:null,
            sms_attachment:null,
            survey_question_affiliated: false,
            survey_question_uuid:null,
            survey_question_answer_value:null,
            is_active:true,
            "last_modified":this.$parent.current_timestamp
          },
          form_data: {
            "org_id":this.$parent.active_org.org_id,
            "user_uuid_created":this.$parent.active_user.user_uuid,
            "user_uuid_last_modified":this.$parent.active_user.user_uuid,
            "script_uuid":null,
            "quick_reply_uuid":null,
            quick_reply_name:null,
            text_short_name:null,
            text_fallback:null,
            text_handlebars:null,
            sms_attachment:null,
            survey_question_affiliated: false,
            survey_question_uuid:null,
            survey_question_answer_value:null,
            is_active:true,
            "last_modified":this.$parent.current_timestamp
          }
        }
      },//modals
      survey_question_uuid_for_watch: null,
      associated_survey_question_input_type: null,
      associated_survey_question: {}
    };
  },
  computed: {
    
  },
  watch: {
    selected_script_uuid_for_watch: {
      handler: function(newVal,oldVal) {
        let these_available_survey_questions = []
        if(newVal && newVal !== null) {
          this.modals.new_quick_reply.form_data.script_uuid = newVal

          //search for selectable survey questions with that script_uuid
          this.$parent.survey_questions.forEach(survey_question => {
            if(survey_question.script_uuid === newVal) {
              these_available_survey_questions.push(survey_question)
            }
          });
        }
        this.available_survey_questions = these_available_survey_questions
      }
    },
    survey_question_uuid_for_watch: {
      handler: function(newVal,oldVal) {

          if(newVal && newVal !== null) {
              this.modals.new_quick_reply.form_data.survey_question_uuid =  newVal 
              this.show_sc_area = true
            //associated_survey_question_input_type  
            this.$parent.survey_questions.forEach(parent_sc => {
              if(parent_sc && parent_sc.survey_question_uuid) {
                if(parent_sc.survey_question_uuid === newVal) {
                  this.associated_survey_question = parent_sc
                  this.associated_survey_question_input_type = parent_sc.input_type
                }
              }
            });
          }

      }
    }
  },
  methods: {
    set_sc_data(msg) {
      this.survey_question_response_data = msg;
      this.modals.new_quick_reply.form_data.survey_question_answer_value = msg
      this.show_sc_area = false
    },
    close_sc_area() {
      this.show_sc_area = false
    },
  
   handle_sc_response_data_function: function(data) {
     console.log(data)
     console.log('handle_sc_response_data_function')

   },
    change_this_quick_reply: function(index,row) {
      this.$nextTick(function () {
        if(!this.changed_row_index_numbers.includes(index)) {
          this.changed_row_index_numbers.push(index)
          this.post_new_row_data(index,row)
        }
      })
    },
    removeItemAll: function(arr, value) {
      var i = 0;
      while (i < arr.length) {
        if (arr[i] === value) {
          arr.splice(i, 1);
        } else {
          ++i;
        }
      }
      return arr;
    },
    post_new_row_data: function(index,row) {
      //let this_row_elements = document.getElementsByClassName("el-table__row")
      //this_row_elements[index].classList.add("table_row_loading");
      

    //TODO is_active bug? i dont know why the status is backwards/not showing in row but it is in the actual parent update
      setTimeout(() => {
        //there is a timing bug vue is fucked?
        console.log('debug is_active')
        console.log(JSON.stringify(row))
        console.log(JSON.stringify(this.$parent.quick_replies[index]))


        this.$parent.cascade_updates_on_new_active_campaign()

        try {
          console.log('rows that have been updated ' + JSON.stringify(index))

          row.user_uuid_last_modified = this.$parent.active_user.user_uuid

          axios.post('https://'+this.$parent.use_this_api_domain+'/quick_reply', row, {
            headers: {
              'Authorization': 'Bearer ' + this.$parent.active_user_jwt
            }
          })
          .then((result,error) => {
            if(result) {
              console.log(result)
              this.$parent.quick_replies[index] = result.data
            } 
            if(error) {
              console.log(error)
              swal.fire({
                title: `Warning`,
                text: 'Error creating new quick_reply',
                buttonsStyling: false,
                icon: 'warning'
              })
            }
            
            this.removeItemAll(this.changed_row_index_numbers,index)

          })
         

        } catch(e) {
          console.log(e)
          swal.fire({
            title: `Warning`,
            text: 'Error creating new quick_reply',
            buttonsStyling: false,
            icon: 'warning'
          })
          // console.log('finally')
          // this.changed_row_index_numbers = []
          // this.is_inside_change_data_callback = false
          this.removeItemAll(this.changed_row_index_numbers,index)
        }


      }, 200);

    },
    toggle_new_quick_reply_modal: function() {
      this.$nextTick(function () {
        this.modals.new_quick_reply.show_modal = true
      })
      
    },
    close_new_quick_reply_modal: function() {
      //reset the data
      this.modals.new_quick_reply.form_data = this.modals.new_quick_reply.default_form_data 

      //clear any erors 
      this.modals.new_quick_reply.errors = []
      //close
      this.modals.new_quick_reply.show_modal = false
      this.modals.new_quick_reply.is_busy = false

    },
    submit_new_quick_reply: function(this_event) {
      this.modals.new_quick_reply.is_busy =  true
      console.log('submiting this quick_reply: ')
      console.log(JSON.stringify(this.modals.new_quick_reply.form_data))
      



      //make sure has a few details
      try {
        if(!this.modals.new_quick_reply.form_data.quick_reply_name) {
          this.modals.new_quick_reply.errors.push("Must have a quick_reply name")
        } else  {
          this.modals.new_quick_reply.errors = this.modals.new_quick_reply.errors.filter(e => e !== "Must have a quick_reply name")
        }

        if(this.modals.new_quick_reply.form_data.quick_reply_name && this.modals.new_quick_reply.form_data.quick_reply_name.length < 7) {
          this.modals.new_quick_reply.errors.push("Please write a longer quick_reply name, at least 8 characters")
        } else {
          this.modals.new_quick_reply.errors = this.modals.new_quick_reply.errors.filter(e => e !== "Please write a longer quick_reply name, at least 8 characters")
        }

        if(!this.modals.new_quick_reply.form_data.text_short_name) {
          this.modals.new_quick_reply.errors.push("Must have basic quick_reply short name")
        } else {
          this.modals.new_quick_reply.errors = this.modals.new_quick_reply.errors.filter(e => e !== "Must have basic quick_reply short name")
        }

        if(!this.modals.new_quick_reply.form_data.script_uuid ||this.modals.new_quick_reply.form_data.script_uuid === null) {
          this.modals.new_quick_reply.errors.push("Must have a script association")
        } else {
          this.modals.new_quick_reply.errors = this.modals.new_quick_reply.errors.filter(e => e !== "Must have a script association")
        }
        

        if(!this.modals.new_quick_reply.form_data.text_fallback) {
          this.modals.new_quick_reply.errors.push("Must have at least text fallback")
        } else {
          this.modals.new_quick_reply.errors = this.modals.new_quick_reply.errors.filter(e => e !== "Must have at least text fallback")
        }

        if(this.modals.new_quick_reply.form_data.is_active === null) {
          this.modals.new_quick_reply.errors.push("Must select active status")
        } else {
          this.modals.new_quick_reply.errors = this.modals.new_quick_reply.errors.filter(e => e !== "Must select active status")
        }

       






        //start here has some errors figre out where

        //if has an attached survey question but no response data
        if(this.modals.new_quick_reply.form_data.survey_question_affiliated && this.modals.new_quick_reply.form_data.survey_question_affiliated === true) {
          if(!this.modals.new_quick_reply.form_data.survey_question_answer_value || this.modals.new_quick_reply.form_data.survey_question_answer_value === null) {
            this.modals.new_quick_reply.errors.push("Must provide data to save into the associated survey question")
          } else {
            this.modals.new_quick_reply.errors = this.modals.new_quick_reply.errors.filter(e => e !== "Must provide data to save into the associated survey question")
          }
        }
      } catch(e) {
        console.log(e)
      }
      
      
      console.log('debug 572')
      if(this.modals.new_quick_reply.errors.length > 0) {
        //do nothing
        console.log(this.modals.new_quick_reply.errors)
        console.log('has errors')
        this.modals.new_quick_reply.is_busy = false
      } else {

        //add the default data from the base
        //TODO maybe it makes more sense to use a computed but im tired
        this.modals.new_quick_reply.form_data.org_id =  this.modals.new_quick_reply.default_form_data.org_id
        this.modals.new_quick_reply.form_data.user_uuid_last_modified =  this.modals.new_quick_reply.default_form_data.user_uuid_last_modified
        this.modals.new_quick_reply.form_data.user_uuid_created =  this.modals.new_quick_reply.default_form_data.user_uuid_created

        console.log('this.modals.new_quick_reply.form_data data')
        console.log(JSON.stringify(this.modals.new_quick_reply.form_data))

        //post the data
        axios.post('https://'+this.$parent.use_this_api_domain+'/quick_reply',  
          this.modals.new_quick_reply.form_data, {
                headers: {
                  'Authorization': 'Bearer ' + this.$parent.active_user_jwt
                }
              })
        .then(response => {
          console.log(response)
          if(response.status === 200) {
            //add the returned data (so it has timestamps etc) into the table
            console.log('new quick_reply created')
            console.log(response.data)
            this.$parent.quick_replies.unshift(response.data)
            //instead of push add to the start... i dont think i need to add though because it's added above
            //this.tableData.unshift(response.data)

          } else {
             swal.fire({
              title: `Warning`,
              text: 'Error creating new quick_reply',
              buttonsStyling: false,
              icon: 'warning'
            })
            
            console.log(response.data)
          }

        })
        .catch(error =>  {
          swal.fire({
            title: `Warning`,
            text: 'Error creating new quick_reply',
            buttonsStyling: false,
            icon: 'warning'
          })
          console.log(error.response.data)
        })
        .finally(has_something => {
          console.log('is done posting new quick_reply data')
          //close the modal
          //reset the data
          this.modals.new_quick_reply.form_data = this.modals.new_quick_reply.default_form_data 

          //clear any erors 
          this.modals.new_quick_reply.errors = []
          //close
          this.modals.new_quick_reply.show_modal = false
          this.modals.new_quick_reply.is_busy = false


        })
      }

    },

    paginationChanged: function(page) {
      this.pagination.currentPage = page
    },
    handleLike: function(index, row) {
      swal.fire({
        title: `You liked ${row.name}`,
        buttonsStyling: false,
        type: 'success',
        confirmButtonClass: 'btn btn-success btn-fill'
      });
    },
    handleEdit: function(index, row) {
      swal.fire({
        title: `You want to edit ${row.name}`,
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-info btn-fill'
      });
    },
    handleDelete: function(index, row) {
      console.log(row);
      swal.fire({
        title: `Are you sure you want to delete ${row.quick_reply_name}?`,
        text: `You won't be able to revert this!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(row);
          swal.fire({
            title: 'Deleted!',
            text: `You deleted ${row.quick_reply_name}`,
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          });
        }
      });
    },
    deleteRow: function(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange: function(selectedRows) {
      this.selectedRows = selectedRows
    },
    handleMouseLeave() {
      this.store.commit('setHoverRow', null);
      if (this.hoverState) this.hoverState = null;
    }
  }
};


</script>
<style>
  .no-border-card .card-footer{
    border-top: 0;
  }
  .table_row_loading {
    opacity: .5;

  }
  div.el-table  .table_row_loading {
    background-color: var(--gray) !important;
  }
  .card .table td, .card .table th, .card .el-table td, .card .el-table th {
    padding-left: 5px;
    padding-right:5px;
  }
</style>
